import { useEffect, useState } from 'react';
import { UserRole } from '../utils/role';
import { readSessionClaims } from '../../../utils/session';

export const useAccount = () => {
  const [user, setUser] = useState<{
    userId: number;
    email: string;
    role?: UserRole;
  }>();

  useEffect(() => {
    const decoded = readSessionClaims<{
      userId: number;
      email: string;
      role: UserRole;
    }>();
    const { userId, email, role } = decoded || {
      userId: 0,
      email: '',
      role: undefined,
    };
    setUser({ userId, email, role });
  }, []);

  return {
    account: user,
  };
};
